import { Observable, of } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { map, switchMap, withLatestFrom } from 'rxjs';
import { cartVariantAndId } from 'src/core/state/cart';
import { catchable } from 'swagger/utils/ajax-helpers';
import { CurrencyActions } from 'src/core/state/currency/browser';
import { Step } from 'src/components/Basket/feature/basket.types';
import { refreshBasketCustomisations } from 'src/components/Basket/utils/refreshBasket';

import { Actions, BasketMsg } from '../basket.actions';
import { Deps } from '../../../../types/global-types';

export function basketRefreshEpic(action$: Observable<any>, state$: Observable<any>, deps: Deps): Observable<any> {
    return action$.pipe(
        ofType<Actions>('Basket.Refresh'),
        withLatestFrom(cartVariantAndId(state$)),
        switchMap(([, [variant, cartId]]) => {
            return refreshBasketCustomisations(variant, cartId!, deps).pipe(
                map(({ updatedAt, customisations, parsedCardId }) => {
                    return BasketMsg('Basket.RefreshSuccess', { updatedAt, customisations, parsedCardId });
                }),
                catchable(({ error }) => {
                    return of(BasketMsg('Basket.RefreshError', error));
                }),
            );
        }),
    );
}

export function basketRefreshOnCurrencyChange(action$: Observable<any>) {
    return action$.pipe(
        ofType<CurrencyActions>('Currency.Set'),
        map(() => BasketMsg('Basket.LoadStep', Step.List)),
    );
}
